import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useEffect } from 'react';
import { TRACKING_EVENT_NAMES, ACTION_SUBJECT_IDS } from '../../utils/constants';
import { bodyStyle, containerStyle, headerStyle, linkStyle } from './error-state.styles';
import { ErrorIcon } from './error-icon';
export const ErrorState = ({ analyticsAttributes }) => {
    const { createAnalyticsEvent } = useAnalyticsEvents();
    useEffect(() => {
        createAnalyticsEvent({
            eventName: TRACKING_EVENT_NAMES.errorScreenDisplayed,
            action: 'displayed',
            actionSubject: 'errorScreen',
            actionSubjectId: ACTION_SUBJECT_IDS.wacCartPopoverErrorScreen,
            attributes: analyticsAttributes
        }).fire();
    }, []);
    return (_jsxs("div", { css: containerStyle, "data-testid": "admin-cart-error-state", children: [_jsx(ErrorIcon, {}), _jsx("h3", { css: headerStyle, children: "Failed to load trial details" }), _jsxs("div", { css: bodyStyle, children: ["We couldn't get info about some of the products you're trialing. Try loading your trial details again. If the problem persists,", ' ', _jsx("a", { css: linkStyle, href: "https://support.atlassian.com/contact", target: "_blank", rel: "noreferrer", children: "contact support" }), "."] })] }));
};
//# sourceMappingURL=error-state.js.map